import { Typography } from "@mui/material";
import React, { Component } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import LoadingCircular from "../LoadingCircular";

// const images = [
//   {
//     original: "http://www.negincompany.com/site/images/1396/04/27/dsc_0043.jpg",
//     thumbnail:
//       "http://www.negincompany.com/site/images/1396/04/27/dsc_0043.jpg",
//   },
//   {
//     original:
//       "http://www.negincompany.com/site/images/1396/04/27/dsc_01051.jpg",
//     thumbnail:
//       "http://www.negincompany.com/site/images/1396/04/27/dsc_01051.jpg",
//   },
//   {
//     original: "http://www.negincompany.com/site/images/1396/04/27/dsc_0132.jpg",
//     thumbnail:
//       "http://www.negincompany.com/site/images/1396/04/27/dsc_0132.jpg",
//   },
//   {
//     original:
//       "http://www.negincompany.com/site/images/1396/04/27/dsc_02621.jpg",
//     thumbnail:
//       "http://www.negincompany.com/site/images/1396/04/27/dsc_02621.jpg",
//   },
//   {
//     original: "http://www.negincompany.com/site/images/1399/04/01/dsc_0010.jpg",
//     thumbnail:
//       "http://www.negincompany.com/site/images/1399/04/01/dsc_0010.jpg",
//   },
//   {
//     original:
//       "http://www.negincompany.com/site/images/1396/04/27/dsc_00871.jpg",
//     thumbnail:
//       "http://www.negincompany.com/site/images/1396/04/27/dsc_00871.jpg",
//   },
// ];

class GalleryDefault extends Component {
  state = { images: [], isLoading: false };
  async componentDidMount() {
    const { galleryId } = this.props;
    this.setState({ isLoading: true });
    const res = await fetch(`/ng/api/GetGallerys/Detail?id=${galleryId}`);
    const data = await res.json();
    const images = data.map((g) => ({
      ...g,
      original: `/ng/Content/Img/Gallery/${galleryId}/${g.original}`,
      thumbnail: `/ng/Content/Img/Gallery/${galleryId}/${g.thumbnail}`,
    }));
    this.setState({ images: images, isLoading: false });
  }
  render() {
    const { images, isLoading } = this.state;
    const { galleryTitle } = this.props;
    return (
      <>
        <LoadingCircular open={isLoading} />
        <Typography sx={{ mb: 3 }} variant="h6">
          {galleryTitle}
        </Typography>
        <ImageGallery items={images} />
      </>
    );
  }
}

export default GalleryDefault;
